import { Iconify } from 'src/components/iconify';
import { SvgColor } from 'src/components/svg-color';

const icon = (name: string) => (
  <SvgColor width="100%" height="100%" src={`/assets/icons/navbar/${name}.svg`} />
);

export const navData = (id: string) => {
  if (id) {
    return [
      {
        title: 'Projects',
        path: '/dashboard',
        icon: <Iconify icon="material-symbols:dashboard" width={20} height={20} />,
      },
      {
        title: 'Main',
        path: `/dashboard/projects/${id}/content`,
        icon: <Iconify icon="material-symbols:experiment-outline" width={20} height={20} />,
        subItems: [
          {
            title: 'Content & Forms',
            path: `/dashboard/projects/${id}/content`,
            icon: <Iconify icon="ix:editor-resources" width={20} height={20} />,
            key: 'content',
          },
          {
            title: 'Campaigns',
            path: `/dashboard/projects/${id}/campaigns`,
            icon: <Iconify icon="material-symbols:experiment-outline" width={20} height={20} />,
            key: 'campaigns',
          },
          {
            title: 'Users',
            path: `/dashboard/projects/${id}/users`,
            icon: <Iconify icon="material-symbols:person-outline" width={20} height={20} />,
          },
          {
            title: 'Audiences',
            path: `/dashboard/projects/${id}/audiences`,
            icon: <Iconify icon="material-symbols:group-outline" width={20} height={20} />,
            key: 'audiences',
          },
          {
            title: 'Events',
            path: `/dashboard/projects/${id}/events`,
            icon: <Iconify icon="material-symbols:event-outline" width={20} height={20} />,
            key: 'events',
          },
        ],
      },
      // {
      //   title: 'Campaigns',
      //   path: `/dashboard/projects/${id}/campaigns`,
      //   icon: <Iconify icon="material-symbols:experiment-outline" width={20} height={20} />,
      // },
      // {
      //   title: 'Content Management',
      //   path: `/dashboard/projects/${id}/content`,
      //   icon: <Iconify icon="ix:editor-resources" width={20} height={20} />,
      // },
      {
        title: 'Remote Config',
        path: `/dashboard/projects/${id}/config`,
        icon: <Iconify icon="si:json-line" width={20} height={20} />,
      },
      {
        title: 'Webhooks',
        path: `/dashboard/projects/${id}/webhooks`,
        icon: <Iconify icon="material-symbols:webhook" width={20} height={20} />,
      },
      // {
      //   title: 'Audiences',
      //   path: `/dashboard/projects/${id}/audiences`,
      //   icon: <Iconify icon="material-symbols:group-outline" width={20} height={20} />,
      // },
      // {
      //   title: 'Events',
      //   path: `/dashboard/projects/${id}/events`,
      //   icon: <Iconify icon="material-symbols:event-outline" width={20} height={20} />,
      // },
      // {
      //   title: 'Users',
      //   path: `/dashboard/projects/${id}/users`,
      //   icon: <Iconify icon="material-symbols:person-outline" width={20} height={20} />,
      // },
      // {
      //   title: 'A/B Tests',
      //   path: `/dashboard/projects/${id}/experiments`,
      //   icon: <Iconify icon="material-symbols:experiment-outline" width={20} height={20} />,
      // },
      // {
      //   title: 'Validations',
      //   path: `/dashboard/projects/${id}/validations`,
      //   icon: <Iconify icon="material-symbols:rule-rounded" width={20} height={20} />,
      // },
      // {
      //   title: 'Functions',
      //   path: `/dashboard/projects/${id}/functions`,
      //   icon: <Iconify icon="ic:round-code" width={20} height={20} />,
      // },
      // {
      //   title: 'Function Settings',
      //   path: `/dashboard/projects/${id}/function-settings`,
      //   icon: <Iconify icon="ic:round-settings" width={20} height={20} />,
      // },
      {
        title: 'Collaborators',
        path: `/dashboard/projects/${id}/collaborators`,
        icon: <Iconify icon="ic:round-group" width={20} height={20} />,
      },
      {
        title: 'Project Settings',
        path: `/dashboard/projects/${id}/app-settings`,
        icon: <Iconify icon="ic:round-settings" width={20} height={20} />,
      },
      {
        title: 'Documentation',
        path: 'https://docs.getresync.com',
        target: '_blank',
        icon: <Iconify icon="material-symbols:book" width={20} height={20} />,
      },
      // {
      //   title: 'Profile',
      //   path: '/dashboard/profile',
      //   icon: <Iconify icon="ic:round-person" width={20} height={20} />,
      // },
    ];
  }

  return [
    {
      title: 'Dashboard',
      path: '/dashboard',
      icon: <Iconify icon="material-symbols:dashboard" width={20} height={20} />,
    },
    // {
    //   title: 'Projects',
    //   path: '/dashboard/projects',
    //   icon: <Iconify icon="material-symbols:apps" width={20} height={20} />,
    // },
    // {
    //   title: 'Collaborators',
    //   path: '/collaborators',
    //   icon: icon('ic-user'),
    // },
    {
      title: 'Organizations',
      path: '/dashboard/organizations',
      icon: <Iconify icon="material-symbols:group" width={20} height={20} />,
    },
    {
      title: 'Profile',
      path: '/dashboard/profile',
      icon: <Iconify icon="material-symbols:person" width={20} height={20} />,
    },
    {
      title: 'Documentation',
      path: '/documentation',
      icon: <Iconify icon="material-symbols:book" width={20} height={20} />,
    },
    // {
    //   title: 'User',
    //   path: '/user',
    //   icon: icon('ic-user'),
    // },
    // {
    //   title: 'Sign in',
    //   path: '/sign-in',
    //   icon: icon('ic-lock'),
    // },
    // {
    //   title: 'Not found',
    //   path: '/404',
    //   icon: icon('ic-disabled'),
    // },
  ];
};
